var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup92TelegramFooterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_3500)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2657 7.15016C21.2392 7.16061 20.6167 7.39802 19.8825 7.6777C19.1482 7.95741 17.6427 8.53278 16.5369 8.95629C15.4311 9.37983 12.7385 10.4101 10.5534 11.2458C8.36834 12.0815 6.46377 12.8208 6.321 12.8888C5.93426 13.073 5.71905 13.3304 5.77281 13.5446C5.79941 13.6505 5.95501 13.8002 6.12136 13.8798C6.19699 13.916 7.12018 14.2135 8.17291 14.5409L10.087 15.1363L10.1835 15.0788C10.2366 15.0473 12.1257 13.8661 14.3816 12.454C16.6374 11.042 18.5887 9.82109 18.7177 9.74096C18.8994 9.62814 18.9912 9.59208 19.1247 9.58101C19.2728 9.56873 19.3021 9.57584 19.3317 9.6312C19.3592 9.68264 19.3517 9.71545 19.2946 9.79375C19.2552 9.8477 18.2893 10.7281 17.1481 11.7502C16.0069 12.7723 14.4362 14.1799 13.6577 14.8781C12.8793 15.5764 12.2391 16.1497 12.2352 16.152C12.2246 16.1584 11.9689 19.7389 11.9689 19.8809V20.0026L12.1056 19.9807C12.1808 19.9687 12.3103 19.9204 12.3935 19.8733C12.4766 19.8263 12.986 19.3644 13.5254 18.8469C14.0648 18.3294 14.5225 17.906 14.5424 17.906C14.5622 17.906 15.4209 18.5233 16.4504 19.2778C17.4799 20.0324 18.4019 20.6872 18.4992 20.733C18.7485 20.8503 19.1107 20.8532 19.2772 20.7392C19.4189 20.6422 19.5705 20.4177 19.6373 20.2061C19.6653 20.1176 20.2551 17.3961 20.9482 14.1583C22.3513 7.60335 22.3019 7.88152 22.1286 7.50965C22.0075 7.24978 21.8477 7.14868 21.5421 7.13864C21.4166 7.13449 21.2923 7.13967 21.2657 7.15016Z",
    fill: "#FF9900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_3500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.4706,
    height: 16.4706,
    fill: "white",
    transform: "translate(5.76465 5.76465)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup92TelegramFooterIcon);
export default __webpack_public_path__ + "static/media/Group 92telegram_Footer_Icon.086b42e29004590753364f3525e0d5c0.svg";
export { ForwardRef as ReactComponent };